import { Fragment } from "react";
import HeaderWeb from "./HeaderWeb";
import { Link, useLocation } from "react-router-dom";

const AccountLayoutWeb = ({ children }) => {
  const location = useLocation();
  let loc = location?.pathname?.split("/")[2];

  return (
    <Fragment>
      <HeaderWeb />{" "}
      <div className="main_wrap">
        <div className="col-left">
          <div className="sub_path">
            <div className="path">
              <a className="path-back" href="#path-pop">
                ...
              </a>
              <ul>
                <li className="path-last">
                  <a href="#">My Account</a>
                </li>
              </ul>
            </div>

            <ul className="menu-list">
              <li>
                <Link
                  to={"/exchange/profile"}
                  className={loc == "profile" ? "select" : ""}
                  id="sub_menu_detail"
                >
                  My Profile
                </Link>
              </li>
              <li>
                <Link
                  to={"/exchange/balance-overview"}
                  className={loc == "balance-overview" ? "select" : ""}
                  id="sub_menu_summary"
                >
                  Balance Overview
                </Link>
              </li>
              <li>
                <Link
                  to={"/exchange/account-statement"}
                  id="sub_menu_accountCashStatement_log"
                  className={loc == "account-statement" ? "select" : ""}
                >
                  Account Statement
                </Link>
              </li>
              <li>
                <Link
                  to={"/exchange/my-bets"}
                  className={loc == "my-bets" ? "select" : ""}
                  id="sub_menu_my_bets"
                >
                  My Bets
                </Link>
              </li>
              <li>
                <Link
                  to={"/exchange/activity-log"}
                  className={loc == "activity-log" ? "select" : ""}
                  id="sub_menu_activity_log"
                >
                  Activity Log
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {children}
      </div>
    </Fragment>
  );
};

export default AccountLayoutWeb;
